import {
  Component,
  EventEmitter,
  HostBinding,
  inject,
  Output,
} from '@angular/core';

import { SideNavComponent } from '../side-nav';

import { FileHashPipe } from '@iss/wo-common/hash-files';
import { IconComponent } from '@iss/core/icon';

@Component({
  selector: 'iss-side-nav-header',
  templateUrl: './side-nav-header.component.html',
  styleUrls: [ './side-nav-header.component.scss' ],
  standalone: true,
  imports: [
    FileHashPipe,
    IconComponent,
  ],
})
export class SideNavHeaderComponent {
  private readonly sideNavComponent = inject(SideNavComponent);

  @Output() public readonly toggle = new EventEmitter<void>();

  @HostBinding('class.iss-expanded')
  public get expanded(): boolean {
    return Boolean(this.sideNavComponent.expanded);
  }
}
